import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

import { ControlsDataZod } from 'types/zod/controls-data';

const ControlsDataApi = {
    get: strictQuery({
        In: z.string(),
        Out: ControlsDataZod,
        handler: (types) => axios.get('/controls-data', { params: { data: types } }),
    }),
};

export default ControlsDataApi;
